// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-transition-enter-active[data-v-6c6de010],\n.expand-transition-leave-active[data-v-6c6de010] {\n  -webkit-transition: height 300ms ease-in-out;\n  transition: height 300ms ease-in-out;\n  overflow: hidden;\n}\n.expand-transition-enter[data-v-6c6de010],\n.expand-transition-leave-to[data-v-6c6de010] {\n  height: 0;\n}", ""]);
// Exports
module.exports = exports;
